"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RotatingCache = void 0;
const logger_lib_support_1 = require("../support/logger-lib-support");
/**
 * Time-based cache, kindof like LRU but works using time instead of count or size.
 *
 * It has two js Maps, one for freshly-accessed items and one for older items that are pending deletion. Every rotationMs, the
 *  new/fresh is rotated, becoming the old, and the old is discarded.
 *
 *  todo: perhaps implement remaining Map interface. (keys, values, size, etc.) Look at how the OSS cache libs handle it
 */
class RotatingCache {
    constructor(args) {
        this._current = new Map();
        this._probation = new Map();
        this._onExpire = args.onExpire;
        this.updateRotationTimer(args.rotationMs);
    }
    get(key) {
        let val = this._current.get(key);
        if (!val) {
            val = this._probation.get(key);
            if (val) {
                this._current.set(key, val);
                this._probation.delete(key);
            }
        }
        return val;
    }
    set(key, val) {
        this._current.set(key, val);
        this._probation.delete(key);
    }
    delete(key) {
        this._current.delete(key);
        this._probation.delete(key);
    }
    has(key) {
        let res = false;
        if (this._current.has(key)) {
            res = true;
        }
        else if (this._probation.has(key)) {
            res = true;
            const val = this._probation.get(key);
            this._current.set(key, val);
            this._probation.delete(key);
        }
        return res;
    }
    hasWithoutTouching(key) {
        return this._current.has(key) || this._probation.has(key);
    }
    updateRotationTimer(rotationMs) {
        this.stopRotationTimer();
        this._rotationMs = rotationMs;
        this._nextTimer();
    }
    stopRotationTimer() {
        clearTimeout(this._timer);
        this._nextRotation = 0;
    }
    getNextRotationDate() {
        return new Date(this._nextRotation);
    }
    expireAllNow() {
        return __awaiter(this, void 0, void 0, function* () {
            let promises = [];
            [this._probation, this._current].forEach(iterable => {
                for (const [key, val] of iterable) {
                    promises.push(this._expireNow(key, val, false));
                }
            });
            yield Promise.allSettled(promises);
        });
    }
    forceExpireNow(key) {
        const val = this._probation.get(key) || this._current.get(key);
        this._expireNow(key, val, true);
    }
    _expireNow(key, val, needsDelete) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._onExpire) {
                try {
                    yield this._onExpire(key, val);
                }
                catch (err) {
                    logger_lib_support_1.loggerIsoLib().warn({ cacheKey: key }, 'Error in RotatingCache onExpire callback');
                }
            }
            if (needsDelete) {
                this.delete(key);
            }
        });
    }
    _nextTimer() {
        this._timer = setTimeout(() => {
            const evicted = this._probation;
            this._probation = this._current;
            this._current = new Map();
            if (this._onExpire) {
                for (const [key, val] of evicted) {
                    this._expireNow(key, val, false);
                }
            }
            this._nextTimer();
        }, this._rotationMs);
        this._nextRotation = Date.now() + this._rotationMs;
    }
}
exports.RotatingCache = RotatingCache;
//# sourceMappingURL=rotating-cache.js.map